<template>
    <div class="div-externa row m-0">
        <div class="meus-contratos px-4 pt-3 pb-0 w-100">
            <div class="title-contrato w-100 mb-3 optum-bold font-24px">
                <DynamicIcon icon="squares" classString="squares-icon mr-2"/> 
                Meus contratos
            </div>
            <div class="cards-contratos custom-scroll-bar d-flex w-100">
                <div v-for="(card, index) in atributosNaoIguais(contrato)" :key="index" class="card-contrato">
                    <div class="card-contrato-title px-3 py-2 ">
                        <p class="optum-bold">{{card.empresa}}</p>
                        <div v-for="(bloco, index) in card.blocoIteravel" :key="index">
                            <div class="bloco-painel-info">
                                <DynamicIcon :icon="bloco.icon" classString="icon mr-2 my-3" />
                                <span class="mr-2 optum-bold">{{bloco.numeroAlert}}</span>
                                <span class="bloco-painel-text mr-2">
                                    {{bloco.title}}
                                </span>
                            </div>       
                        </div>
                    </div>
                    <div class="p-3">
                        <div class="card-contrato-sobre pb-2 mb-2">
                            <p class="mb-2 optum-bold">Sobre o programa:</p>
                            <DynamicIcon icon="blue-squares" classString="icon"/>  {{ card.produtos }} <br/>
                            <DynamicIcon icon="blue-telefone" classString="icon"/>  {{card.numero0800}} <br/>
                        </div>
                        <div class="card-contrato-ultima-carga pb-2 mb-2">
                            <p class="mb-2 optum-bold">Última carga:</p>
                            <DynamicIcon icon="blue-calendar" classString="icon"/>  {{card.dataUltimaImportacao}} <br/>
                            <DynamicIcon icon="blue-person" classString="icon"/>  {{card.usuario}} <br/>
                        </div>
                        <div class="card-contrato-responsavel">
                            <p class="mb-2 optum-bold">Responsável pelo contrato:</p>
                            <DynamicIcon icon="blue-person" classString="icon"/>  {{card.responsavel}} <br/>
                            <div class="d-flex">
                                <DynamicIcon icon="blue-letter" classString="icon mr-1"/>  <p class="p-link">{{card.email}}</p><br/>
                            </div>                            
                        </div>
                    </div>                   
                </div>
            </div>
        </div>
        <div class="atalhos-funcoes w-100 px-4 py-3 d-flex col-12 m-0">
            <div class="col-12 col-md-9 p-0"> 
                <div class="atalhos d-flex">
                    <div class="font-24px w-100 pb-2 optum-bold">
                        <DynamicIcon icon="lamp" classString="icon-lamp"/> 
                        Precisa de ajuda para importar os beneficiários ?
                    </div>
                    <div class="row m-0">
                        <!-- <div class="card-btn px-2 mx-2 col-12 col-md-3 mb-2" @click="showVideo">
                            <DynamicIcon icon="video" classString="icon mr-2 my-3"/> 
                            <p class="optum-bold">Assista o vídeo tutorial</p> 
                        </div> -->
                        <div class="card-btn px-2 mx-2 col-12 col-md-3 mb-2" @click="showManual">
                            <DynamicIcon icon="multiple-letter" classString="icon mr-2 my-3"/> 
                            <p class="optum-bold">Leia o manual</p> 
                        </div>
                        <div class="card-btn px-2 mx-2 col-12 col-md-3" @click="downloadModelo">
                            <DynamicIcon icon="folder" classString="icon mr-2 my-3"/> 
                            <p class="optum-bold">Baixe o modelo em branco</p> 
                        </div>
                    </div>
                    
                    <div class="footer w-100 mt-4">
                        Se ainda precisar de ajuda, entre em contato conosco através do e-mail carga.lss@optum.com.br
                    </div>                    
                </div>                
            </div>
            <div class="col-3"> <DynamicIcon icon="people" classString="icon-people"/> </div>
        </div>

        <b-modal id="modal-manual-importacao" hide-footer centered body-class="modal-manual-importacao body-class container" size="lg" no-close-on-backdrop no-close-on-esc
        @hidden="$emit('close')">
            <div class="col-md-12" v-if="pdfPreview">
                    <embed :src="pdfPreview" width="100%" height="500"  type="application/pdf" v-if="pdfPreview" />
                </div>
        </b-modal>

        <b-modal id="modal-video-importacao" hide-footer centered body-class="modal-video-importacao body-class container" size="lg" no-close-on-backdrop no-close-on-esc
        @hidden="$emit('close')">
            <div class="col-md-12" v-if="blobVideo">
                    <Video :blob-video="blobVideo" :autoplay="true"/>
                </div>
        </b-modal>


    </div>
</template>

<script>
import UserResource from "@/resources/UserResource"
import DynamicIcon from "@/components/commons/dynamicIcon/DynamicIcon.vue";
import HomeResource from "@/resources/HomeResource"
import EmpresaResource from "@/resources/EmpresaResource"
import Video from "@/components/commons/Video"
import DateUtils from "@/util/DateUtils"
import BeneficiarioImportacaoResource from "@/resources/BeneficiarioImportacaoResource"

const bloco = {
    blocoIteravel: [],
    produtos: null,
    dataUltimaImportacao: null
}

export default {
    name: "MasterPageContent",
    components: { DynamicIcon, Video },
    data() { 
        return {
            blocoIteravel: [],
            pdfPreview: null,
            blobVideo: null,
            contrato : []
        }
    },
    computed:{
        blocoIteravelComputed(){
            return [...this.blocoIteravel]
        }
    },
    methods: {
        downloadModelo() {
			HomeResource.downloadModelo()
		},
        showManual() {
			HomeResource. getPreviewManual({ showLoader: true})
            .then((pdfPreview) => {
                this.pdfPreview = pdfPreview
                this.$bvModal.show('modal-manual-importacao')
            })
		},
        showVideo() {
			HomeResource.getPreviewVideo({ showLoader: true})
            .then((videoPreview) => {
                this.blobVideo = videoPreview
                this.$bvModal.show('modal-video-importacao')
            }) 
		},
        getDataUltimaImportacao( contrato ) {
            return contrato.dataUltimaImportacao ? DateUtils.format( contrato.dataUltimaImportacao.substring(0,19) ) : ''
        },
        atributosNaoIguais(arrayDeObjetos) {
            const nomesUnicos = [];
            
            // Cria um objeto para rastrear quais nomes já foram vistos
            const nomesVistos = {};

            // Itera pelos objetos no array
            for (const objeto of arrayDeObjetos) {
                const nome = objeto.empresa;

                // Verifica se o nome já foi visto
                if (!nomesVistos[nome]) {
                    nomesUnicos.push(objeto);
                    // Marca o nome como visto
                    nomesVistos[nome] = true; 
                }
            }
            
            return nomesUnicos;
        },
        async getTotalTitularesAtivos(empresaId)
        {
            return {
                icon: "man",
                numeroAlert : await this.getTotal( 1, 1, empresaId),
                title: "Total de titulares ativos",
            }
        },
        async getTotalDependentesAtivos(empresaId)
        {
            return {
                icon: "family",
                numeroAlert : await this.getTotal( 2, 1, empresaId),
                title: "Total de dependentes ativos",
            }
        },
        async getTotalBeneficiariosAtivos (empresaId)
        {
            return {
                icon: "group",
                numeroAlert : await this.getTotal( null, 1, empresaId),
                title: "Total de beneficiários ativos",
            }
        },
        async getTotal( tipo, status, empresa)
        {
            try {
                let result = await BeneficiarioImportacaoResource.totalBeneficiario( tipo, status, empresa, {showLoader: false})
                
                result = JSON.parse(result)

                if(result.data)
                {
                    return result["data"] || 0
                }

                return result 
                
            } catch (error) {
                return 0
            }
        },
        getQtdBeneficiarioByEmpresa(empresaId)
        {
            return this.blocoIteravel[empresaId] ? this.blocoIteravel[empresaId] : []
        },
        getContratos(){
            UserResource.contrato({ showLoader: false})
            .then( contratos => {

                if(!Array.isArray(contratos))
                    contratos = []

                contratos.forEach(async item => {
                    let contrato = {...bloco, ...item}

                    let array = await EmpresaResource.contratoOptions( item.empresaId, {showLoader: true} )
                    if(!Array.isArray(array)) 
                        array = [array]
                    array = array.map(elem => elem.text )

                    contrato.produtos = array.join(", ")
                    contrato.dataUltimaImportacao = this.getDataUltimaImportacao( item )
                    contrato.blocoIteravel = await Promise.all([ this.getTotalTitularesAtivos(item.empresaId), 
                        this.getTotalDependentesAtivos(item.empresaId), this.getTotalBeneficiariosAtivos(item.empresaId) 
                        ])

                    this.contrato.push(contrato)
                })
            })
        }
    },
    created() { 
        this.getContratos()
    }
}
</script>

<style scoped lang="scss">
.bloco-painel-info {
    display: flex;
    align-items: center;
    min-width: 280px;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    margin: 0;

}
.bloco-painel-text {
    word-break: break-all;
    color: #5A5A5A;
}
.atalhos-funcoes{
    background-color: $screenSecundaryBgColor;
    color: $primaryColor;
}

.meus-contratos .title-contrato{
    color: $primaryColor;
    display: flex;
    align-items: center;
}

.meus-contratos .title-contrato .squares-icon{
    height: 25px;
    margin-bottom: 0px !important;
}

.atalhos-funcoes .icon-people{
    width: 200px;
    height: 150px;
}

.atalhos-funcoes .icon-lamp{
    width: 45px;
    height: 45px;
    margin-bottom: 10px !important
}

.atalhos-funcoes .atalhos{
    font-size: 20px;
    text-align: initial;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
}

.atalhos-funcoes .footer{
    font-size: 12px;
    font-weight: 600;
    text-align: initial;
    color: $tipographyColor;
}

.card-btn{
    border: 1px solid #D1D1D1;
    font-size: 16px;
    background: #FFFFFF;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: initial;
    max-height: 60px;
}

.card-btn:hover{
    cursor: pointer;
    background: #d1d1d1;
}

.card-btn .icon{
    width: 50px;
}

.cards-contratos{
    overflow-x: scroll;
}

.card-contrato{
    min-width: 26%;
    max-width: 26%;
    margin-right: 20px;
    border: 1px solid #D1D1D1;
    border-radius: 10px;
    margin-bottom: 10px;
    overflow: hidden;
    text-align: initial;
}

.card-contrato .card-contrato-title{
    font-family: 'optum-sans', sans-serif;
    background-color: $screenSecundaryBgColor;
    color: $primaryColor;
    font-weight: 600;
    min-height: 80px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    font-weight: 700;
    font-size: 20px;
    line-height: 24px;
}

.card-contrato-sobre, .card-contrato-ultima-carga{
    border-bottom: 1px solid #D1D1D1;
}

.card-contrato-sobre, .card-contrato-ultima-carga,.card-contrato-responsavel{
    color: $tipographyColor;
    font-size: 14px;
}

.card-contrato-sobre p, .card-contrato-ultima-carga p,.card-contrato-responsavel p{
    color: $tipographyColor;
    font-weight: 600;
    font-size: 13px;
}

.cards-contratos .icon{
    height: 20px;
    margin-bottom: 5px !important;
}

@media (max-width: 1200px) {
    .card-btn{
        font-size: 12px;
    }

    .card-btn .icon{
        width: 40px;
    }
}

@media (max-width: 1023px) {
    .card-contrato {
        min-width: calc(100% - 40px);
    }
}

@media (max-width: 770px) {
    .atalhos-funcoes > .col-3 {
        display: none;
    }
}

@media (max-width: 450px) {
    .card-contrato {
        min-width: calc(100% - 40px);
    }
}
</style>